<template>
	<v-container>
		<h1>En lista de espera</h1>
		<span v-if="folio == 0"><v-row>
				<v-col cols="12">
					<LlamadasAsignacion @llamadas-asignacion="llamadaAsignacion"/>
				</v-col>
			</v-row>
		</span>
		<span v-if="folio != 0">
			<v-row>
				<v-col cols="12">
					<DetalleAsignacion @cancela-detalle="cancelaDetalle" :datosAsignacion="datosAsignacion"/>
				</v-col>
			</v-row>
		</span>
	</v-container>
</template>

<script>
import LlamadasAsignacion from '@/components/LlamadasAsignacion'
import DetalleAsignacion from '@/components/DetalleAsignacion'
export default{
	name: 'EnEspera',
	components: {
		LlamadasAsignacion,
		DetalleAsignacion,
	},
	data(){
		return {
			folio: 0,
			datosAsignacion: {},
		}
	},
	mounted: function(){
		if(!this.$session.exists()){
			this.$router.push('login')
		} else {
			this.nombreUsuario = this.$session.get('nombre')
			this.esAdmin = this.$session.get('esAdmin')
			if(!this.esAdmin){
				this.$router.push('/')
			}
		}
	},
	methods:{
		llamadaAsignacion(event){
			console.log("En Espera", event)
			this.folio = event.folio
			this.datosAsignacion = event
		},
		cancelaDetalle(event){
			this.folio = event
		},
	}
}
</script>
